import React from 'react'
import TableCommande from '../../Components/table/TableCommande'

const Commande = () => {
  return <TableCommande />
}

export default Commande
